Vendd.Scripts.load(function () {
    'use strict';

    var $wrapper = $('.x-cart'),
        wrapper;

    if ($wrapper.length < 1)
        return;

    if ($(window).width() < 768) {
        stickyNavigation();
    }

    wrapper = $wrapper.get(0);

    var model = null, firstLoad = true, wishlistModel;
    var lazyloadAvailabilities = $wrapper.data("lazyload-availabilities");
    lazyloadAvailabilities = lazyloadAvailabilities === "True" ? true : false;

    var isProductReplacingEnabled = LhApp.Context.Modules.ProductReplacingTypesModule.IsEnabled; /* is Product Replacing Module Enabled */

    Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.GetUserViewModel());

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.DownLoadExcelSuccess, wrapper, function (envelope, status, headers, config) {

        var today = new Date(), dd = today.getDate(), mm = today.getMonth() + 1, yyyy = today.getFullYear(),
			data = envelope.message.data, opt = { type: "application/vnd.ms-excel" };

        if (dd < 10) { dd = '0' + dd; }
        if (mm < 10) { mm = '0' + mm; }
        today = dd + '/' + mm + '/' + yyyy;

        var fname = model.WidgetLiterals.CartText + '-' + today + '.xls',
			blb = new Blob([toArrayBuffer(data._buffer)], opt), file = new File([blb], fname), dlnk = $('.js-GetExcel-cart', $wrapper);

        if (model && model.WidgetLiterals && model.WidgetLiterals.CartText && model.WidgetLiterals.CartText.length > 0) {
            fname = model.WidgetLiterals.CartText + " - " + today + ".xls";
        }

        dlnk.attr('href', URL.createObjectURL(file));
        dlnk.attr('download', file.name);
        dlnk.removeClass('loading');

    });

    wrapper.loading = function loading(loading) {
        if (loading) {
            $wrapper.addClass('x-loading');
        } else {
            $wrapper.removeClass('x-loading');
        };
    };

    wrapper.update = function update() {
        wrapper.loading(true);

        if (firstLoad) {
            model.Messages = _.union(model.Messages, cartMessages);
            firstLoad = false;
        }
        if (isProductReplacingEnabled) {
            model.IsProductReplacingEnabled = isProductReplacingEnabled;
            _.each(model.Items, function (product, index) {
                if (product.ReplacableTypeId === 1) {
                    model.Items[index].IsReplacableTypeOne = true;
                } else if (product.ReplacableTypeId === 2) {
                    model.Items[index].IsReplacableTypeTwo = true;
                } else if (product.ReplacableTypeId === 3) {
                    model.Items[index].IsReplacableTypeThree = true;
                }
            });

            model.IsReplacingProductExists = typeof (_.first(_.filter(model.Items, function (x) { return x.ReplacableTypeId !== null; }))) !== "undefined" ? true : false;
        }

        if (wishlistModel) {
            _.each(wishlistModel.Items, function (item) {
                _.each(model.Items, function (x) {
                    if (item.VariantId === x.VariantId) {
                        x.AlreadyInWishlist = true;
                        x.WishlistId = item.Id;
                        return;
                    }
                });
            });
        }

        var html = Vendd.Handlebars.parse("cart", model);
        wrapper.bind(html, model);

        if ($('.js-GetExcel-cart', $wrapper).length > 0) {
            wrapper.GetExcel();
        }
        if (isProductReplacingEnabled) {
            checkAllProductsReplacability();
        }

        wrapper.loading(false);
    };

    wrapper.success = function success() {
        wrapper.update();
        wrapper.alert();

        if (model.IsEmpty) {
            $('.mobile-container').addClass('no-products-in-cart');
            $('.side-content .box-four').addClass('no-products-in-cart');
        } else {
            $('.mobile-container').removeClass('no-products-in-cart');
            $('.side-content .box-four').removeClass('no-products-in-cart');
        }
    };

    wrapper.GetExcel = function () {

        var dlnk = $('.js-GetExcel-cart', $wrapper);
        dlnk.addClass('loading');

        var Ids = [];
        for (var i = 0; i < model.Items.length; i++)
            Ids.push(model.Items[i].VariantId);
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.DownLoadExcel(Ids));

    };

    wrapper.bind = function bind(html, bindModel) {
        $wrapper.html(html);

        $('.x-cart-qty-selector.incremental', wrapper).each(function (i, el) {
            var $this, value, min, max, quanta, $decrBtn, $incrBtn;
            model = bindModel;

            $this = $(this);
            value = parseFloat((stringToNumber($this.children('input[name="qty"]').val()) ? stringToNumber($this.children('input[name="qty"]').val()) : null) || 0);
            min = parseFloat(($(this).closest("li").attr("data-min-quantity") ? stringToNumber($(this).closest("li").attr("data-min-quantity")) : null) || 1);
            max = parseFloat(($(this).closest("li").attr("data-max-quantity") ? stringToNumber($(this).closest("li").attr("data-max-quantity")) : null) || 100000);

            $decrBtn = $this.children('.js-decrement');
            $incrBtn = $this.children('.js-increment');

            if (isNaN(value) || isNaN(min) || isNaN(max)) {
                console.error('Error found in quantity selector\'s values');
            }

            if (value === min) {
                $decrBtn.addClass('disabled');
                $decrBtn.attr('disabled', 'disabled');
            }

            if (value === max) {
                $incrBtn.addClass('disabled');
                $incrBtn.attr('disabled', 'disabled');
            }
        });

        formatPrices($wrapper);
        initTooltips();

        $('.js-expand-combo', $wrapper).click(function () {
            $(this).closest('.cart-item').siblings().find('.combo-item-wrapper.expanded').removeClass('expanded').children('.combo-title').removeClass('icon-arrow-up').addClass('icon-arrow-down');
            $(this).parent().toggleClass('expanded');
            $(this).toggleClass('icon-arrow-down icon-arrow-up');
        });

        if ($('li.cart-item').length > 1) {
            $('.items-header .products-count').removeClass('hidden');
        }

        if ($('.js-notification-warning', $wrapper).length > 0) {
            if ($('.js-notification-warning', $wrapper).data('reason') === 'DailyTradingLimitReached' || $('.js-notification-warning', $wrapper).data('reason') === 'TradingRestriction') {
                $('.js-notification-warning', $wrapper).addClass('visible');
            } else {
                $('.js-notification-warning', $wrapper).removeClass('visible');
            }
        }

    };

    wrapper.bindAvailabilities = function bindAvailabilities(deliveryPointModel) {

        //set delivery point
        var deliveryPointId = deliveryPointModel.data.DeliveryPoint.Id;
        //set if has store
        var hasStore = deliveryPointModel.data.HasStore;
        //set selected postal code
        var deliveryPostalCode = Cookies.get('DeliveryPostalCode');

        if (deliveryPointId == 1 && deliveryPostalCode && deliveryPostalCode !== 'undefined') {

            //set an array with all products
            var variantArray = [];

            _.each(model.Items, function (item) {
                var variant = {
                    VariantId: item.VariantId,
                    Quantity: item.Quantity
                };
                variantArray.push(variant);
            });

            //call service for delivery availabilities
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Product.Messages.GetDeliveryAvailability(variantArray, deliveryPostalCode, null, true));

            Vendd.MessageBus.subscribe(Vendd.Product.Messages.GetDeliveryAvailabilitySuccess, wrapper, function (envelope) {
                var data = envelope.message.data;

                //extend cart model
                _.extend(model, { HasOrderAvailability: true, OrderAvailabilityMessage: data.OrderAvailability.Message });

                //extend cart items model
                var deliveryAvailabilities = _.each(model.Items, function (item) {
                    var selectedProduct = _.find(data.DeliveryAvailabilities, function (x) { return item.VariantId === x.Variant })
                    if (selectedProduct) item.AvailabilityActionName = selectedProduct.Message;
                });

                _.extend(model.Items, deliveryAvailabilities);

                //proceed with update
                wrapper.success();

                Vendd.MessageBus.unsubscribe(Vendd.Product.Messages.GetDeliveryAvailabilitySuccess, wrapper);
            });

        } else if (deliveryPointId == 2 && hasStore) {

            //set selected shop id
            var partnerId = deliveryPointModel.data.Store.Id

            //set an array with all products
            var variantArray = [];

            _.each(model.Items, function (item) {
                var variant = {
                    VariantId: item.VariantId,
                    Quantity: item.Quantity
                };
                variantArray.push(variant);
            });

            //call service for pick up availabilities
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Product.Messages.GetPickUpAvailability(variantArray, partnerId, true));

            Vendd.MessageBus.subscribe(Vendd.Product.Messages.GetPickUpAvailabilitySuccess, wrapper, function (envelope) {
                var data = envelope.message.data;

                //extend cart model
                _.extend(model, { HasOrderAvailability: true, OrderAvailabilityMessage: data.OrderAvailability.Message });

                //extend cart items model
                var pickupAvailabilities = _.each(model.Items, function (item) {
                    var selectedProduct = _.find(data.PickupAvailabilities, function (x) { return item.VariantId === x.Variant })
                    if (selectedProduct) item.AvailabilityActionName = selectedProduct.Shops[0].Message;
                });

                _.extend(model.Items, pickupAvailabilities);

                //proceed with update
                wrapper.success();

                Vendd.MessageBus.unsubscribe(Vendd.Product.Messages.GetPickUpAvailabilitySuccess, wrapper);
            });
        } else {
            //proceed with update
            wrapper.success();
        }     

    };

    $wrapper.on('click', '.js-GetExcel-cart', function (e) {

        var $this = $(this);
        if ($this.hasClass('loading')) {
            return false;
        }

    });

    $wrapper.on('click', '.js-remove', function (e) {
        var $this = $(this),
            $item = $this.closest('.cart-item');

        var id = $item.data('identifier');

        wrapper.loading(true);

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.Remove(id));
    });

    $wrapper.on('click', '.js-add-to-wishlist', function (e) {
        var $this = $(this),
            $box, $qty,
            id, skuId, path, qty, extraAttributes, bundleItems;

        if ($this.closest('.wishlist-button').hasClass('x-disabled'))
            return;

        $box = $this.closest('.cart-item');
        $qty = $('.js-quantity', $box);

        id = $box.data('productid');
        skuId = $box.data('variantid');
        path = $box.data('path');
        qty = $qty.val() || 1;
        extraAttributes = [];
        bundleItems = [];

        if (LhApp.Context.MultipleWishlistsEnabled && $('.js-wishlist-lists', $box).length > 0) {
			var check = $('.x-wishlist-list', $box).length < 1;
			LhApp.Function.hideAllProductWishlists();
			if (check) {
				var product = { id: id, skuId: skuId, path: path, qty: qty };
				LhApp.Function.showProductWishlists($box, product);
			}
		} else {
			Vendd.MessageBus.publishAsync($box.get(0), new Vendd.Wishlist.Messages.Add(id, skuId, path, qty, extraAttributes, bundleItems));
        }

    });

    $wrapper.on('click', '.js-remove-from-wishlist', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $this = $(this), $box, wishlistItemId;

        if ($this.closest('.wishlist-button').hasClass('x-disabled'))
            return;

        $box = $this.closest('.cart-item');
        wishlistItemId = $box.data('wishlistitemid');

        Vendd.MessageBus.publishAsync($box.get(0), new Vendd.Wishlist.Messages.Remove(wishlistItemId));
    });

    $wrapper.on('click', '.js-refresh', function (e) {
        var $this = $(this),
            $item = $this.closest('.cart-item');

        var id = $item.data('identifier');
        var qty;
        if ($this.hasClass('dropdown')) {
            qty = stringToNumber($('.js-selector.dropdown', $item).val());
        } else if ($this.hasClass('free-text')) {
            qty = stringToNumber($('.js-selector.free-text', $item).val());
        } else {
            qty = stringToNumber($('input[name="qty"]', $item).val());
        }
        wrapper.loading(true);

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.SetQuantity(id, qty));
    });

    $wrapper.on('change', '.js-giftwrap-checkbox', function (e) {
        var $this = $(this),
            giftWrapBox = $this.closest('.js-toggle-checkbox-giftwrap').siblings('.js-giftwrap-selection');

        if ($this.is(":checked")) {
            giftWrapBox.show();
        } else {
            giftWrapBox.hide();
        }
    });

    $wrapper.on('change', '.js-giftwrap-selector', function (e) {
        var $this = $(this),
            $item = $this.closest('.x-giftwrap'),
            $selector = $('.js-giftwrap-selector', $item);
        var giftwrapItemId = $selector.val();

        if (giftwrapItemId == 0) {
            $('.js-set-giftwrap', $item).parent().addClass('hidden');
        }
        else {
            $('.js-set-giftwrap', $item).parent().removeClass('hidden');
        }

        $('.js-giftwrap-wrapper', $item).addClass('hidden');
        $('.js-giftwrap-wrapper-' + giftwrapItemId, $item).removeClass('hidden');
    });

    $wrapper.on('click', '.js-set-giftwrap', function (e) {
        var $this = $(this),
            $item = $this.closest('.cart-item'),
            $selector = $('.js-giftwrap-selector', $item),
            giftwrapItemId = $selector.val(),
            $giftwrapWrapper = $('.js-giftwrap-wrapper-' + giftwrapItemId, $item),
            $message = $('.js-giftwrap-message textarea', $giftwrapWrapper);


        var id = $item.data('identifier'),
            message = $message.length > 0 ? $message.val() : '';
        wrapper.loading(true);
        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.SetGiftwrap(id, giftwrapItemId, message));
    });

    $wrapper.on('click', '.js-delete-giftwrap', function (e) {
        var $this = $(this),
            $item = $this.closest('.cart-item');

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.SetGiftwrap($item.data('identifier'), 0, ''));
    });

    $wrapper.on('change', '.js-allowances-or-charges-apply', function (e) {
        var $this = $(this),
            $item = $this.closest('.cart-item');
        var id = $item.data('identifier');
        var thisId = this.id
        thisId = thisId.substr(0, thisId.indexOf('_'));

        if (this.checked) {
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.ApplyExtraAllowanceOrCharge(id, thisId));
        } else {
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.DisableExtraAllowanceOrCharge(id, thisId));
        }
    });

    $wrapper.on('click', '.js-remove-all', function (e) {
        wrapper.loading(true);

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.Clear());
    });

    $wrapper.on('click', '.js-refresh-all', function (e) {
        var $items = $('.cart-item', $wrapper);
        var items = [];

        $.each($items, function (i, item) {
            var $item = $(item),
                item = {};

            item.id = $item.data('identifier');
            item.qty = stringToNumber($('input[name="qty"]', $item).val());

            items.push(item);
        });

        wrapper.loading(true);

        Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.SetQuantities(items));
    });

    $wrapper.on('click', '.js-qty-change', function (e) {
        var $this, $spinner, $input, val, min, max, step;

        if (model === undefined)
            alert("undefined");

        $this = $(this);
        if ($this.hasClass('disabled')) return;
        $spinner = $this.parent();
        $input = $this.siblings('input[name="qty"]').eq(0);
        val = ($input.val() ? stringToNumber($input.val()) : null) || 1;
        min = ($(this).closest("li").attr("data-min-quantity") ? stringToNumber($(this).closest("li").attr("data-min-quantity")) : null) || 1;
        max = ($(this).closest("li").attr("data-max-quantity") ? stringToNumber($(this).closest("li").attr("data-max-quantity")) : null) || 100000;
        step = ($(this).closest("li").attr("data-quanta") ? stringToNumber($(this).closest("li").attr("data-quanta")) : null) || 1;


        if (isNaN(val) || isNaN(min) || isNaN(max) || isNaN(step)) {
            console.error('Error found in quantity selector\'s values');
        }

        if ($this.hasClass('js-decrement')) {

            if (min === "" && max === "" && step === "") {
                min = parseInt($spinner.data('min'));
                max = parseInt($spinner.data('max'));
                step = parseInt($spinner.data('step'));
                val = parseInt(val) - parseInt(step);
            }
            else if (Vendd.Helpers.isInteger(parseFloat(step))) {
                val = parseInt(val) - parseInt(step);
            }
            else if (parseFloat(val) > parseFloat(min) && (parseFloat(val) - parseFloat(step) >= parseFloat(min))) {
                val = parseFloat(val) - parseFloat(step);
                val = parseFloat(val).toFixed(2);
            }
            $input.val(numberToString(val));
            $this.siblings('.js-increment').removeClass('disabled');
            $this.siblings('.js-increment').removeAttr('disabled');

            if (parseFloat(val) === parseFloat(min)) {
                $this.addClass('disabled');
                $this.attr('disabled', 'disabled');
            }
        } else if ($this.hasClass('js-increment')) {

            if (min === "" && max === "" && step === "") {
                min = parseInt($spinner.data('min'));
                max = parseInt($spinner.data('max'));
                step = parseInt($spinner.data('step'));
                val = parseInt(val) + parseInt(step);
            }
            else if (Vendd.Helpers.isInteger(parseFloat(step))) {
                val = parseInt(val) + parseInt(step);
            }
            else if (parseFloat(val) < parseFloat((max == null || max === "" || max <= 0 ? 1000000 : max)) && (parseFloat(val) + parseFloat(step)) <= parseFloat((max == null || max === "" || max <= 0 ? 1000000 : max))) {
                val = parseFloat(val) + parseFloat(step);
                val = parseFloat(val).toFixed(2);
            }

            $input.val(numberToString(val));
            $this.siblings('.js-decrement').removeClass('disabled');
            $this.siblings('.js-decrement').removeAttr('disabled');

            if (parseFloat(val) === parseFloat(max)) {
                $this.addClass('disabled');
                $this.attr('disabled', 'disabled');

            }
        }
        if ($('.js-refresh').length > 0)
            $spinner.siblings('.js-refresh').trigger('click');
    });

    $wrapper.on('keydown', '.js-quantity', function (e) {
        numbersOnly(e);
    });

    /*Replacable Product Module logic*/

    if (isProductReplacingEnabled) {
        $wrapper.on('change', '.js-replacable-all', function (e) {
            var $replacableAll = $(this);

            $('.cart-item.isReplacable', $wrapper).each(function () {
                var $cartItem = $(this);

                if ($replacableAll.prop('checked')) {
                    $('.js-replacable-product', $cartItem).prop('checked', true);
                } else {
                    $('.js-replacable-product', $cartItem).prop('checked', false);
                }
                toggleReplacablePhonecall($cartItem, $('.js-replacable-product', $cartItem).prop('checked'));
            });

            updateReplacingTypedIdModel();

        });

        $wrapper.on('change', '.js-replacable-product', function (e) {
            var $cartItem = $(this).closest('.cart-item.isReplacable');
            toggleReplacablePhonecall($cartItem, $(this).prop('checked'));

            updateReplacingTypedIdModel();
            checkAllProductsReplacability();
        });

        $wrapper.on('change', '.js-replacable-phonecall', function (e) {
            updateReplacingTypedIdModel();
            checkAllProductsReplacability();
        });

        function toggleReplacablePhonecall(replacableProd, isReplacable) {
            if (isReplacable) {
                $('.js-replacable-phonecall', replacableProd).removeAttr("disabled");
            } else {
                $('.js-replacable-phonecall', replacableProd).attr("disabled", true);
                $('.js-replacable-phonecall', replacableProd).prop('checked', false);
            }
        }

        function getReplacingTypedId(replacableProd) {
            if ($('.js-replacable-product', replacableProd).prop('checked')) {
                if ($('.js-replacable-phonecall', replacableProd).prop('checked')) {
                    return 2;
                }
                return 1;
            } else {
                return 3;
            }
        }

        function updateReplacingTypedIdModel() {
            var replacableModel = [];
            var productModel = {};

            $('.cart-item.isReplacable', $wrapper).each(function () {
                var $cartItem = $(this);

                productModel = {
                    "CartProductId": $cartItem.data('identifier'),
                    "ProductId": $cartItem.data('variantid'),
                    "ProductReplaceingTypeId": getReplacingTypedId($cartItem)
                }
                replacableModel.push(productModel);
            });

            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.UpdateCartProductReplacingTypes(replacableModel));
        }
    }

    function checkAllProductsReplacability() {
        if (isAllReplacable()) {
            $('.js-replacable-all').prop('checked', true);            
        } else if (isNoneReplacable()) {
            $('.js-replacable-all').prop('checked', false);            
        }
    }

    function isAllReplacable() {
        var allReplacable = true;

        $('.cart-item.isReplacable', $wrapper).each(function () {
            if (!$('.js-replacable-product', $(this)).prop('checked')) {
                allReplacable = false;
                return;
            }
        });

        return allReplacable;
    }

    function isNoneReplacable() {
        var noneReplacable = true;

        $('.cart-item.isReplacable', $wrapper).each(function () {
            if ($('.js-replacable-product', $(this)).prop('checked')) {
                noneReplacable = false;
                return;
            }
        });

        return noneReplacable;
    }

    /*END Replacable Product Module logic*/
    $wrapper.on('change', '.js-selector.dropdown', function (e) {
        if (model === undefined)
            alert("undefined");

        if ($('.js-refresh').length > 0)
            $(this).parent().siblings('.js-refresh').trigger('click');
    });

    $wrapper.on('change', '.js-selector.free-text', function (e) {
        if (model === undefined)
            alert("undefined");

        var $this = $(this);

        var qty = $this.val();
        var minQty = $this.parent().data('min');
        var maxQty = $this.parent().data('max');
        var quanta = $this.parent().data('quanta');
        var unitType = $this.parent().data('unit-type');

        if (isNaN(qty) || isNaN(minQty) || isNaN(maxQty) || isNaN(quanta)) {
            console.error('Error found in quantity selector\'s values');
        }

        if (qty >= minQty && (qty <= maxQty || !maxQty)) {
            if (unitType === 'int') {
                qty = parseInt(qty);
                if (quanta) {
                    if (qty >= quanta) {
                        qty = Math.round(qty / quanta) * quanta;
                    } else {
                        qty = quanta;
                    }
                }

                $this.val(qty);
            }
            else if (unitType === 'decimal') {
                qty = parseFloat(qty);
                if (quanta) {
                    if (qty >= quanta) {
                        qty = Math.round(qty / quanta) * quanta;
                    } else {
                        qty = quanta;
                    }
                }

                $this.val(qty.toFixed(2));
            }
        } else {
            if (maxQty && $this.val() > maxQty) {
                qty = maxQty;
                $this.val(qty);
            } else {
                if (minQty) {
                    qty = minQty;
                    $this.val(qty);
                } else if (quanta) {
                    qty = quanta;
                    $this.val(qty);
                } else {
                    qty = 1;
                    $this.val(1);
                }
            }
        }

        if ($('.js-refresh').length > 0)
            $this.parent().siblings('.js-refresh').trigger('click');
    });

    var message = '', shown = true;
    wrapper.alert = function () {
        if (message) {
            if (!shown) {
                shown = true;
                $('.js-alert-message').html(message).addClass('visible');
                if ($(window).scrollTop() > $('.js-alert-message').offset().top - 100) {
                    $('html,body').animate({ scrollTop: $('.js-alert-message').offset().top - 100 }, 500);
                }
            } else {
                message = '';
            }
        }
    };

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, wrapper, function (envelope) {
        model = envelope.message.data.Cart; 

        //set delivery point model
        var deliveryPointModel = JSON.parse(localStorage.getItem("CurrentDeliveryPointModel"));
        var hasDeliveryPoint = false;
        if (deliveryPointModel) if (deliveryPointModel.data.HasDeliveryPoint) hasDeliveryPoint = true;

        if (lazyloadAvailabilities && deliveryPointModel && hasDeliveryPoint) {
            wrapper.bindAvailabilities(deliveryPointModel);
        } else {
            wrapper.success();
        }      

    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Failed, wrapper, function (envelope) {
        wrapper.loading(false);
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Warning, wrapper, function (envelope) {
        wrapper.loading(false);
    });

    Vendd.MessageBus.subscribe(Vendd.Cart.Messages.ShowMessages, wrapper, function (envelope) {
        var messages = envelope.message.data.resultMessages;
        if (messages.length > 0) {
            message = messages.join('\n');
            shown = false;
            //wrapper.alert(message);
        }
    });

    Vendd.MessageBus.subscribe(Vendd.DeliveryPoint.Messages.ResetStoreSuccess, wrapper, function (envelope) {
        //reset model
        model.HasOrderAvailability = false;
        model.OrderAvailabilityMessage = null;
        _.each(model.Items, function (item) {
            item.AvailabilityActionName = null;
        });
        //proceed with update
        wrapper.success();
    });

    Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.AddSuccess, wrapper, function (envelope) {
        var response = envelope.message.data;

        if (response.code !== "RequiresAuthenticationError") {
            /* Track Add To Wishlist */
            if (typeof fbPixelTracker !== 'undefined' && typeof fbPixelCanTrack !== 'undefined') {
                if (fbPixelTracker && fbPixelTracker.Properties.FacebookPixelId && fbPixelCanTrack) {
                    fbq('track', 'AddToWishlist');
                }
            }
            /* END Track Add To Wishlist */
            toastr.success(LhApp.Function.getText("Common:ProductAddedToWishlist"), "", { timeOut: 1500, showDuration: 600, hideDuration: 700 });
        } else {
            toastr.warning(response.data.ErrorMessage, "", { timeOut: 1500, showDuration: 600, hideDuration: 700 });
        }
    });

    Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.RemoveSuccess, wrapper, function (envelope) {
        var response = envelope.message.data;

        if (response.code !== "RequiresAuthenticationError") {
            /* Track Remove From Wishlist */
            if (typeof fbPixelTracker !== 'undefined' && typeof fbPixelCanTrack !== 'undefined') {
                if (fbPixelTracker && fbPixelTracker.Properties.FacebookPixelId && fbPixelCanTrack) {
                    fbq('track', 'RemoveFromWishlist');
                }
            }
            /* END Track Remove From Wishlist */
            toastr.success(LhApp.Function.getText("Common:ProductRemovedFromWishlist"), "", { timeOut: 1500, showDuration: 600, hideDuration: 700 });
        } else {
            toastr.warning(response.data.ErrorMessage, "", { timeOut: 1500, showDuration: 600, hideDuration: 700 });
        }
    });

    Vendd.MessageBus.subscribe(Vendd.Wishlist.Messages.Changed, wrapper, function (envelope) {
        wishlistModel = envelope.message.data;

        var $boxes = $('.cart-item');
        
        if ($boxes.length < 1)
            return;

        $boxes.each(function (i, el) {
            var $el = $(el);
            var id = $el.data('variantid');

            if (wishlistModel.Items) {
                var productInWishlist = _.find(wishlistModel.Items , function (x) { return id === x.VariantId });
                var $wishlistButton = $('.wishlist-button', $el);

                if (productInWishlist) {
                    $el.data('wishlistitemid', productInWishlist.Id);
                    $wishlistButton.addClass('already-in-wishlist');
                    $('.js-add-to-wishlist', $wishlistButton).addClass('disabled');
                    $('.js-remove-from-wishlist', $wishlistButton).removeClass('disabled');
                } else {
                    $wishlistButton.removeClass('already-in-wishlist');
                    $('.js-add-to-wishlist', $wishlistButton).removeClass('disabled');
                    $('.js-remove-from-wishlist', $wishlistButton).addClass('disabled');
                }
            }
        });

    });

    var currentUrl = window.location.href;
    var _isCartPage = currentUrl.toLowerCase().indexOf("/cart/") !== -1;

    Vendd.MessageBus.publishAsync(wrapper, new Vendd.Cart.Messages.GetModel(_isCartPage));

});


function stickyNavigation() {
    var header = $('.header-template-checkout');
    var headerHeight = header.height();
    var container = $('.mobile-container');
    var containerHeight = container.height();
    var spacer = $('.navigation-spacer');

    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    $(window).scroll(_.throttle(initSticky, 10));

    function initSticky() {
        var st = $(this).scrollTop();
        // Make sure they scroll more than delta
        if (Math.abs(lastScrollTop - st) <= delta)
            return;

        //Sticky in top
        if ($(window).scrollTop() < headerHeight) {
            container.removeClass('sticky');
            spacer.height(0);
        } else {
            container.addClass('sticky');
            spacer.height(containerHeight);
        }

        //Hide when user scrolls to cart summary
        if ($(window).scrollTop() > ($('.side-content').offset().top - 100)) {
            container.addClass('hidden');
        } else {
            container.removeClass('hidden');
        } 

        lastScrollTop = st;
    }
}
